import { render } from "./recordLottery.vue?vue&type=template&id=047b0e96&scoped=true"
import script from "./recordLottery.vue?vue&type=script&lang=js"
export * from "./recordLottery.vue?vue&type=script&lang=js"

import "./recordLottery.vue?vue&type=style&index=0&id=047b0e96&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-047b0e96"]])

export default __exports__